import { IOperationAllow, Operation } from '..';
import {
  find as lfind,
  propOr as lpropOr,
  compose as lcompose,
} from 'lodash/fp';
import { concatAll } from 'fp-ts/lib/Monoid';
import { MonoidAny } from 'fp-ts/lib/boolean';

export const canOperate =
  (operations: IOperationAllow[]) => (operation: Operation) =>
    lcompose(
      lpropOr(false, 'allow'),
      lfind<IOperationAllow>({
        operation,
      })
    )(operations);

export const disableOperationsHelpDesk = (operations: IOperationAllow[]) =>
  concatAll(MonoidAny)([
    canOperate(operations)('helpDesk'),
    canOperate(operations)('rps'),
  ]);

export const disableOperationsDiversionInv = (operations: IOperationAllow[]) =>
  canOperate(operations)('di');
